module.exports = __webpack_public_path__ + "img/Asset-11@3x-1-1024x218.6226e8f4.png";